import Button from 'components/Button';
import SortableContainer from 'components/Sortable/SortableContainer';
import SortableItem from 'components/Sortable/SortableItem';
import SupersendAddDocument from 'components/Supersend/components/SupersendDocuments/SupersendAddDocument';
import SupersendAddZip from 'components/Supersend/components/SupersendDocuments/SupersendAddZip';
import SupersendDocument from 'components/Supersend/components/SupersendDocuments/SupersendDocument';
import SupersendDocumentContainer from 'components/Supersend/components/SupersendDocuments/SupersendDocumentContainer';
import {ComponentProps, FC} from 'react';
import {t} from 'ttag';

type ItemProps = ComponentProps<typeof SupersendDocument>;

type AttachedDocumentsListProps = {
    isSortable?: boolean;
    items: ItemProps[];
    onItemsChange?: (items: ItemProps[]) => void;
    onPreviewFiles: () => void;
};

const AttachedDocumentsList: FC<AttachedDocumentsListProps> = ({
    isSortable = false,
    items,
    onItemsChange,
    onPreviewFiles,
}) =>
    items.length === 0 ? null : (
        <div className="my-2 flex gap-2">
            <SupersendDocumentContainer className="flex-1">
                {isSortable && (
                    <>
                        <SortableContainer
                            items={items.map((item) => ({
                                ...item,
                                id: item.mid,
                            }))}
                            onSortChange={onItemsChange}
                            renderItem={(item) => (
                                <SortableItem id={item.id} key={item.id}>
                                    <SupersendDocument
                                        isEditing={true}
                                        {...item}
                                    />
                                </SortableItem>
                            )}
                            sortingStrategy="grid"
                        />
                        <SupersendAddDocument />
                        <SupersendAddZip />
                    </>
                )}
                {!isSortable &&
                    items.map((item) => (
                        <SupersendDocument key={item.mid} {...item} />
                    ))}
            </SupersendDocumentContainer>
            <Button
                kind="secondary"
                onClick={onPreviewFiles}
                size="sm"
            >{t`Preview Files`}</Button>
        </div>
    );

export default AttachedDocumentsList;
